import { AuthGuard } from './auth/auth.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router'; 
import { RegistrationComponent } from './user/registration/registration.component';
import { LoginComponent } from './user/login/login.component';
import { HomeComponent } from './home/home.component';
import { ChangePassComponet } from './user/changePass.component';
import { ActivationComponet } from './activation/activation.component';
import { CountriesDataComponent } from './countries/countriesData.component';
import { CountriesAuditLogsComponent } from './auditLog/countriesAuditLogs/countriesAuditLogs.component';
import { AuditLogComponent } from './auditLog/auditLog.component';
import { ActivatorAuditLogsComponent } from './auditLog/activatorAuditLogs/activatorAuditLogs.component';
import { CryptComponet } from './crypt/crypto.component';

const routes: Routes = [
    { path: '', redirectTo: '/login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent  },
    {
        path: 'registration', component: RegistrationComponent, canActivate: [AuthGuard]
    },    
    {
        path: 'changePass', component: ChangePassComponet
    },
    {
        path: 'activation', component: ActivationComponet, canActivate: [AuthGuard]
    },
    {
        path: 'countriesData', component: CountriesDataComponent, canActivate: [AuthGuard]
    },
    {
        path: 'auditLog', component: AuditLogComponent, canActivate: [AuthGuard],
        children: [

            { path: 'countriesAuditLogs/:idCountry/:amountDaysCountryAuditLogs', component: CountriesAuditLogsComponent },
            { path: 'activatorAuditLogs/:amountDaysActivatorAuditLogs', component: ActivatorAuditLogsComponent }
        ]
    },
    {
        path: 'crypt', component: CryptComponet 
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: "reload", useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
